import { NowArrowIcon } from "@tandemdiabetes/sugarmate-react-components"
import dayjs from "dayjs"
import {
  useCallback,
  useMemo,
} from "react"
import { useGraphContext } from "../GraphContext"
import styles from "./GraphHeaderButton.module.scss"
import { usePolyglot } from "src/contexts"

export function GraphNowButton() {
  const polyglot = usePolyglot()

  const {
    listRef,
    graphScrollDate,
    graphEnd,
    zoom,
  } = useGraphContext()

  const disabled = useMemo(
    () => {
      /*
       * the time that represents the centerpoint on the graph when scrolled to the end
       * with a 1 minute buffer
       */
      const graphNow = dayjs(graphEnd)
        .subtract(
          zoom / 2,
          "hours",
        )
        .subtract(
          1,
          "minute",
        )

      // true if graphScrollDate is after or equal to "now"
      return !dayjs(graphScrollDate).isBefore(graphNow)
    },
    [
      graphEnd,
      graphScrollDate,
      zoom,
    ],
  )


  const onNowClick = useCallback(
    () => {
      listRef.current?.scrollTo(0)
    },
    [listRef],
  )

  return (
    <button
      onClick={onNowClick}
      className={styles.button}
      disabled={disabled}
      id="now-button"
    >
      {polyglot.t("pages.home.graph.header.now_cta")}
      <NowArrowIcon />
    </button>
  )
}
